import React from 'react';
import styled, { useTheme } from 'styled-components';
import { RemoveIc, CheckmarkIc } from '@dsch/dd-icons';

export interface VerifiedListProps {
  layout?: 'SINGLE_LINE' | 'TWO_COLUMN';
  verification?: { email: boolean; phone: boolean; identity: boolean };
  className?: string;
}

const P = styled.div<Pick<VerifiedListProps, 'layout'>>`
  ${({ theme, layout }) =>
    layout === 'SINGLE_LINE' ? theme.fontSize.S12 : theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
`;

const VerifiedContainer = styled.div<Pick<VerifiedListProps, 'layout'>>`
  display: grid;
  row-gap: ${({ theme }) => theme.spacing.S8};
  column-gap: ${({ theme }) => theme.spacing.S8};
  grid-template-columns: ${({ layout }) =>
    layout === 'TWO_COLUMN' ? 'repeat(2, 1fr)' : 'repeat(4, min-content)'};

  @media (min-width: 1024px) {
    margin-bottom: ${({ theme, layout }) =>
      layout === 'TWO_COLUMN' && theme.spacing.L56};
    column-gap: ${({ theme }) => theme.spacing.S8};
  }

  ${P}:last-child {
    grid-column: ${({ layout }) => (layout === 'TWO_COLUMN' ? 'span 2' : '0')};
  }
`;

const IconContainer = styled.div`
  margin-right: ${({ theme }) => theme.spacing.S4};
`;

const SP = styled(P)`
  color: ${({ theme }) => theme.colors.GREY};
`;

function VerifiedList({
  layout = 'SINGLE_LINE',
  verification,
  className,
}: VerifiedListProps) {
  const theme = useTheme();
  return (
    layout && (
      <VerifiedContainer layout={layout} className={className}>
        {layout === 'SINGLE_LINE' && <P layout={layout}>Verified:</P>}
        {verification &&
          Object.keys(verification).map(
            (verify: 'email' | 'phone' | 'identity') =>
              verification[verify] ? (
                <P key={verify} layout={layout}>
                  <IconContainer>
                    <CheckmarkIc
                      color={theme.colors.GREEN}
                      width="16"
                      height="16"
                    />
                  </IconContainer>
                  {verify} {layout === 'TWO_COLUMN' && 'Verified'}
                </P>
              ) : (
                <SP key={verify} layout={layout}>
                  <IconContainer>
                    <RemoveIc
                      color={theme.colors.GREY}
                      width="16"
                      height="16"
                    />
                  </IconContainer>
                  {verify} {layout === 'TWO_COLUMN' && 'Not Verified'}
                </SP>
              ),
          )}
      </VerifiedContainer>
    )
  );
}

export { VerifiedList };
